import React, { useEffect } from 'react'
import SearchBar from './searchbar'
import NavBar from './navbar'
import RightNav from './rightNav'
import '../../../css/components/public/header.css'
import { Link } from 'react-router-dom'
import Logo2 from '../../../images/logo4.jpg'
import { useRef,useState } from 'react'
import Button from '../../forms/blackfillButton'
import ApiUrl from '../../../configTools/apiUrl'

const Index = ({HomeSwitch,SetHomeSwitch,menuOpen,setMenuOpen,openChatBox,setOpenChatBox}) => {
  const [bag,setBag] = useState(JSON.parse(localStorage.getItem("product-cart")));
  const [bagsum,setBagSum] = useState(0);
  useEffect(()=>{
    if(bag){
      const sum = bag.reduce((accumulator, object) => {
        return accumulator + object.price;
      }, 0);
      setBagSum(sum);
    }
  },[bag])
  const cartBox = useRef(null);
  const cartBoxSlider = useRef(null);
  function cartBoxToggle(){
      if(cartBox.current.className.includes('active')){
        cartBoxSlider.current.className = 'cartbox_slider';
        setTimeout(() => {
            cartBox.current.className = 'cartbox_wrapper';
        }, 500);
      }
      else{
        cartBox.current.className = 'cartbox_wrapper active';
        setTimeout(() => {
            cartBoxSlider.current.className = 'cartbox_slider active';
        }, 500);
      }
  }
  return (
    <>
      <div className='mainHeader_Wrapper'>
        <div className='mainHeader_top_Wrapper'>
          <div className='mainHeader_top_container'>
            <div className='mainHeader_logo'>
              <Link to='/' onClick={()=>{SetHomeSwitch(0); setMenuOpen(false);}}>
                <img src={Logo2} alt="logo"/>
              </Link>
            </div>
            <div className='mainHeader_searchBar'>
                <SearchBar/>
            </div>
            <div className='mainHeader_rightCover'>
                <RightNav cartBoxToggle={cartBoxToggle} Bag={bag}  menuOpen={menuOpen} setMenuOpen={setMenuOpen} openChatBox={openChatBox} setOpenChatBox={setOpenChatBox}/>
            </div>
          </div>
        </div>
        <div className='mainHeader_nav_wrapper'>
          <div className='mainHeader_nav_container'>
            <NavBar/>
          </div>
        </div>
      </div>
      <div className='cartbox_wrapper' ref={cartBox}>
          <div className='cartbox_close' onClick={cartBoxToggle}></div>
          <div className='cartbox_container'>
              <div className='cartbox_slider' ref={cartBoxSlider}>
                  <div className='cartbox_title'>
                      <h4>Shoping Bag</h4>
                  </div>
                  <div className='cartbox_items'>
                    {bag &&
                      bag.map((item,index)=>{
                        return(
                          <div key={index} className='cart_box_item'>
                            <div className='cart_box_item_image'>
                              <img src={ApiUrl.API_URL_Image_Thumbnail+item.image} alt='pro_image'/>
                            </div>
                            <div className='cart_box_item_details'>
                              <Link to={"/product/"+item.slug}>
                                <h5>{item.title}</h5>
                              </Link>
                              {item.hasvarients &&
                                <div className='cart_box_item_details_container'>
                                  <div className='cart_box_item_details_item'>
                                    <p>Size:</p>
                                    <p>{item.sizeName}</p>
                                  </div>
                                  <div className='cart_box_item_details_item'>
                                    <p>Color:</p>
                                    <div style={{backgroundColor:item.colorcode}} className={"cart_box_item_details_item_colorcode"}></div>
                                  </div>
                                </div>
                              }
                              <div className='cart_box_item_details_remove'>
                                <p onClick={()=>{
                                  var newbag = [];
                                  for (let i = 0; i < bag.length; i++) {
                                    const element = bag[i];
                                    if(index !== i){
                                      newbag.push(element);
                                    }
                                  }
                                  localStorage.setItem("product-cart",JSON.stringify(newbag));
                                  setBag(newbag);
                                }}>Remove</p>
                              </div>
                            </div>
                            <div className='cart_box_item_price'>
                              <p>{"Rs."+item.price+"/-"}</p>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                  <div className='cartbox_bottom'>
                      <div className='cartbox_total'>
                          <div className='cartbox_total_title'><h5>Total</h5></div>
                          <div className='cartbox_total_title'><h5>Rs{bagsum}/-</h5></div>
                      </div>
                      <Link to={"/checkout"}>
                        <Button Value={"Checkout"}/>
                      </Link>
                  </div>
              </div>
          </div>
      </div>
    </>
  )
}

export default Index
